// Translations
export const T = {
  en_GB: {
    noCostDataAvailable: "No cost data available for this portfolio.",
    description: "Description",
    afterOneYear: "After 1 year",
    afterNYears: (n: number) => `After ${n} years`,
    deposits: "Deposits",
    expectedValueBeforeCost: "Expected value before cost",
    expectedValueAfterCost: "Expected value after cost",
    reductionInReturn: "Reduction in return",
    expectedReturn: "Expected return",
    expectedReturnAfterCost: "Expected return after cost",
    calculated: "Calculated",
  },
  nb_NO: {
    noCostDataAvailable: "Ingen kostnadsdata tilgjengelig for denne porteføljen.",
    description: "Beskrivelse",
    afterOneYear: "Etter 1 år",
    afterNYears: (n: number) => `Etter ${n} år`,
    deposits: "Innskudd",
    expectedValueBeforeCost: "Forventet verdi før kostnader",
    expectedValueAfterCost: "Forventet verdi etter kostnader",
    reductionInReturn: "Reduksjon i avkastning",
    expectedReturn: "Forventet avkastning",
    expectedReturnAfterCost: "Forventet avkastning etter kostnader",
    calculated: "Beregnet",
  },
} as const;
